<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">Modal Header</slot>
        </header>
        <section class="modal-body">
          <slot name="body">Modal Body</slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">Modal Footer</slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal"
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000000;
}
.modal {
  margin-top: 15vh;
  margin-left: 12.5%;
  width: 75%;
  max-height: 70vh;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  border-radius: 4px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  z-index: 1000001;
}
.modal-header {
  padding: 15px;
  display: flex;
}
.modal-footer {
  padding: 15px;
  display: flex;
}
.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #144c74;
  justify-content: space-between;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}
.modal-body {
  position: relative;
  overflow-y: scroll;
  padding: 15px;
}
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
</style>
